import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/modal";
import { Flex, Button } from "@chakra-ui/react";
import { PartnerFormSub } from "components/partnerForm";
import { AdminContext } from "context";
import { EDateTimeFormat, EToastStatus, EPartnerFields } from "enums";
import React, { useState, useContext, useEffect, useRef } from "react";
import { IPartnerRes } from "types";
import moment from "moment";
import { createPartner } from "services";

interface AddPartnerModalProps {
  showModal: boolean;
  onDecline: () => void;
  action: () => void;
  data?: IPartnerRes;
}

export const AddPartnerModal = ({
  showModal,
  onDecline,
  data,
  action,
}: AddPartnerModalProps) => {
  const cancelRef = useRef(null);
  const [fields, setFields] = useState<IPartnerRes>(data);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<IPartnerRes>();
  const { showToast } = useContext(AdminContext);

  useEffect(() => {
    setFields({
      ...data,
    });
  }, [data]);

  const handleChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setError(null);
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  };

  const handleAddPartner = async () => {
    try {
      if (!fields?.name) {
        return setError({ ...error, name: "Name is require!" });
      }
      setIsSubmitting(true);
      await createPartner(fields);
      showToast("Success", "Create Partner success!", EToastStatus.SUCCESS);
      action();
      onDecline();
    } catch (error: any) {
      showToast("Error", error?.response?.data?.message, EToastStatus.ERROR);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Modal
      finalFocusRef={cancelRef}
      onClose={onDecline}
      isOpen={showModal}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Partner</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Flex gap={6} flexDirection="column">
            <Flex gap={6}>
              <PartnerFormSub.Input
                name={EPartnerFields.Name}
                value={fields?.name}
                onChange={handleChangeInput}
                error={error?.name}
              />
            </Flex>
            <Flex gap={6}>
              <PartnerFormSub.Input
                disabled={true}
                name={EPartnerFields.CreatedTime}
                value={moment(fields?.createdTime).format(
                  EDateTimeFormat.MONTH_DAY_YEAR
                )}
              />
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter gap={5}>
          <Button
            isLoading={isSubmitting}
            isDisabled={!!error}
            colorScheme="purple"
            onClick={handleAddPartner}
          >
            Add
          </Button>
          <Button ref={cancelRef} onClick={onDecline}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
